import { Controller } from "stimulus";

// Shows/hides the mural composer card from the hero button, keeping the feed clean by default.
export default class extends Controller {
  static targets = ["panel"];

  toggle() {
    this.panelTarget.hidden = !this.panelTarget.hidden;
    if (!this.panelTarget.hidden) {
      const firstField = this.panelTarget.querySelector("input, trix-editor, textarea");
      if (firstField) firstField.focus();
    }
  }
}
